import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';

import { fetchMusicStart } from '../../redux/music/music.actions';

import { LoaderContainer, Dot1Container, Dot2Container, Dot3Container } from './loader.style';

const Loader = () => {
	const dispatch = useDispatch();

    useEffect(() => {
		const musicFetch = fetchMusicStart();
		dispatch(musicFetch);
    }, [dispatch]);

    return (
        <LoaderContainer>
            <Dot1Container />
            <Dot2Container />
            <Dot3Container />
        </LoaderContainer>
    );
};

export default Loader;
